import { Form, InputNumber } from 'antd'
import React, { FC } from 'react'

import { spacesToProperty } from '../../../utilities/general'
import { validateProperty } from '../../../utilities/validators/baseValidator'
import { FormFloatLabel } from './formFloatLabel'
import {
  FormError,
  FormInput,
  getError,
  getRules,
  handleFormChange,
} from './util'

interface FormNumber extends FormInput {
  min: number
}

export const FormNumber: FC<FormNumber> = ({
  disabled = false,
  element,
  initialValue,
  label = null,
  min = 0,
  name,
  noFloat = false,
  parentProperty = null,
  required = false,
  section = null,
  setElement,
  validator,
  width = '100%',
}) => {
  const error: FormError = element && getError(name, element)

  const onChange = (value: string) => {
    if (!value) value = '0'
    const updatedElement = handleFormChange(
      name,
      parentProperty,
      value,
      element,
    )
    validateProperty(
      validator,
      updatedElement,
      name,
      parentProperty,
      required,
      section,
    )
    setElement(updatedElement)
  }

  const inputContent = (
    <InputNumber
      min={min?.toString() ?? '0'}
      autoComplete='off'
      className={`${noFloat ? 'no-float' : ''}`}
      style={{ width: width }}
      value={initialValue?.toString() ?? '0'}
      formatter={(value: string) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      parser={(value: string) => value.replace(/\$\s?|(,*)/g, '')}
      onChange={(value: string) => onChange(value)}
      disabled={disabled}
    />
  )

  let input

  if (noFloat) {
    input = inputContent
  } else {
    input = (
      <FormFloatLabel
        label={
          label || spacesToProperty(typeof name === 'string' ? name : name[1])
        }
        name={name}
        inputValue={initialValue ? initialValue : '0'}
      >
        {inputContent}
      </FormFloatLabel>
    )
  }

  if (!error && !validator) {
    return (
      <div className='form-item-validation-container'>
        <Form.Item name={name}>{input}</Form.Item>
      </div>
    )
  }

  if (error) {
    return (
      <div className='form-item-validation-container'>
        <Form.Item
          name={name}
          validateStatus='error'
          help={error.message}
        >
          {input}
        </Form.Item>
      </div>
    )
  }

  return (
    <div className='form-item-validation-container'>
      <Form.Item
        name={name}
        rules={[getRules(typeof name === 'string' ? name : name[1], required)]}
      >
        {input}
      </Form.Item>
    </div>
  )
}
